import React from "react";
import ConnectionsListWidget from "../../components/Widgets/ConnectionsWidgets/ConnectionsListWidget";

const DataConnectionsPage = () => {
  return <ConnectionsListWidget />;
};
export default DataConnectionsPage;
